import {useState, useEffect} from 'react'
import {apiAgent} from '../../../axiosConfig.js'
import {useSelector} from 'react-redux'
import { Button } from '../../../design_system/components/Button/Button.jsx'
import { Avatar } from '../../../design_system/components/Avatar/Avatar.jsx'
import { canUseMemberManagementAction, isCustomerTeamAdmin } from '../../../utils/access.js'


const TeamMembershipRequests = ({ onCountChange }) => {

  const [membershipRequests, setMembershipRequests] = useState([]);
  const current_team = useSelector(state => state.current_team.team)
  const current_user = useSelector(state => state.current_user.user)
  const customerTeamAdmin = isCustomerTeamAdmin({ team: current_team })
  const canApproveMembers = canUseMemberManagementAction({ permissionKey: "members.approve", user: current_user, team: current_team })

  useEffect(() => {
    apiAgent({
      menthod: 'get',
      url: '/team_members',
      params: {
        approval_status: 'pending'
      }
    }).then(res => {
        if(res.data){
          setMembershipRequests(res.data.data)
          onCountChange?.(res.data.total_count || res.data.data.length)
        }
    }).catch(err => {
        console.log("Error from ActiveTeamMembers component did mount", err)
    })
  }, [onCountChange])


  const acceptRequest = (index) => {
    let temp = [...membershipRequests]
    temp[index].isApproving = true;
    setMembershipRequests(temp);
    apiAgent({
      method: 'post',
      url: `/team_members/${membershipRequests[index].id}/approve`,
      data: {}
    }).then(res => {
      let temp = [...membershipRequests]
      temp.splice(index, 1)
      setMembershipRequests(temp)
      onCountChange?.(temp.length)
    }).catch(err => {
      console.log("From Approval Request TeammemberReques component", err)
      let temp = [...membershipRequests]
      temp[index].isApproving = false;
      setMembershipRequests(temp);
    })
  }

  const rejectRequest = (index) => {
    let temp = [...membershipRequests]
    temp[index].isRejecting = true;
    setMembershipRequests(temp);
    apiAgent({
      method: 'post',
      url: `/team_members/${membershipRequests[index].id}/reject`,
      data: {}
    }).then(res => {
      let temp = [...membershipRequests]
      temp.splice(index, 1)
      setMembershipRequests(temp)
      onCountChange?.(temp.length)
    }).catch(err => {
      let temp = [...membershipRequests]
      temp[index].isRejecting = false;
      setMembershipRequests(temp);
      console.log("From Approval Request TeammemberReques component", err)
    })
  }

  return(
    <div className="data-fields__table-wrap mt-0">
      <table className="data-fields__table manage-teams__table">
        <thead>
          <tr>
            <th className="body-m-bold" style={{width: '20%'}}>Name</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {membershipRequests.map((member, index) => (
            <tr key={member.id}>
              <td>
                <div className="manage-teams__name-cell">
                  <Avatar name={member.user.name || member.user.email} width={40} />
                  <div>
                    <div className="body-s-bold">{member.user.name || "No name"}</div>
                    <div className="body-s color-text-secondary">{member.user.email}</div>
                  </div>
                </div>
              </td>
              <td className="text-left">
                {canApproveMembers && (customerTeamAdmin || member.team_role === "regular") && (
                  <div className="flex items-center justify-start gap-s">
                    <Button Size="Small"
                      disabled={member.isRejecting} isLoading={member.isApproving}
                      onClick={() => acceptRequest(index)}>
                      Approve
                    </Button>
                    <Button Size="Small" Type="Secondary"
                      disabled={member.isApproving} isLoading={member.isRejecting}
                      onClick={() => rejectRequest(index)}>
                      Decline
                    </Button>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default TeamMembershipRequests
